/**
 * Returns the URL unchanged if it uses a safe protocol, otherwise "#".
 * Use whenever rendering a URL that originates from CMS / external input.
 */
export function safeUrl(url: string | null | undefined): string {
  if (!url) return "#"
  if (url.startsWith("/") || url.startsWith("#")) return url
  try {
    const u = new URL(url)
    return ["https:", "http:", "mailto:", "tel:"].includes(u.protocol)
      ? url
      : "#"
  } catch {
    return "#"
  }
}

const OWN_HOST_RE = /(?:^|\.)aheadhealth\.(?:com|dev)$|(?:^|\.)vercel\.app$/i

/**
 * True when the href points to a different origin than our own — i.e. it
 * should open in a new tab. Relative paths, anchors, mailto:/tel:, and
 * URLs on aheadhealth.com, aheadhealth.dev, or *.vercel.app are considered
 * internal.
 */
export function isExternalHref(href: string | null | undefined): boolean {
  if (!href) return false
  if (href.startsWith("/") || href.startsWith("#")) return false
  try {
    const u = new URL(href)
    if (u.protocol !== "http:" && u.protocol !== "https:") return false
    return !OWN_HOST_RE.test(u.hostname)
  } catch {
    return false
  }
}
